import { render } from "./App.vue.js?vue&type=template&id=8dfa4df1!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=template&id=8dfa4df1"
import script from "./App.vue.js?vue&type=script&lang=js!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&lang=js"
export * from "./App.vue.js?vue&type=script&lang=js!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=script&lang=js"

import "./App.vue.css?vue&type=style&index=0&id=8dfa4df1&lang=css!=!../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./App.vue?vue&type=style&index=0&id=8dfa4df1&lang=css"

import exportComponent from "../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__